import { PLAYER_KD_REFRESH_INTERVAL_MS } from '@shared/playerKD';

export const KD_REFRESH_INTERVAL_MS = PLAYER_KD_REFRESH_INTERVAL_MS;

type VisibilitySource = {
    readonly hidden: boolean;
    addEventListener(type: 'visibilitychange', callback: () => void): void;
    removeEventListener(type: 'visibilitychange', callback: () => void): void;
};

// Keep reads serial, pause hidden tabs, and refresh on returning to the panel.
export function startAutoRefresh(refresh: () => Promise<void>, {
    intervalMs = KD_REFRESH_INTERVAL_MS,
    immediate = true,
    visibility = document as VisibilitySource,
} = {}) {
    let stopped = false;
    let running = false;
    const run = async () => {
        if (stopped || running || visibility.hidden) return;
        running = true;
        try {
            await refresh();
        } catch {
            // The caller owns the error display; retry on the next interval.
        } finally {
            running = false;
        }
    };
    const timer = setInterval(run, intervalMs);
    visibility.addEventListener('visibilitychange', run);
    if (immediate) void run();
    return () => {
        stopped = true;
        clearInterval(timer);
        visibility.removeEventListener('visibilitychange', run);
    };
}
